<table id="bookPages" style="margin-left: auto; margin-right: auto;">
  <tbody>
  <!-- Page number row -->
  <tr *ngIf="showPageNumbers" class="page-number-row">
    <td class="page-number-cell page-number-cell-left">
      <div *ngIf="leftPageNumber !== 0">{{ leftPageNumber | numberFormat }}</div>
    </td>
    <td class="page-number-cell page-number-cell-right">
      <div *ngIf="rightPageNumber < draft.draftBody.numPages">{{ rightPageNumber | numberFormat }}</div>
    </td>
  </tr>

  <!-- Page content row -->
  <tr [style.margin-top.px]="showPageNumbers ? 0 : 50">
    <td id="evenPageWrapper">
<!--      <div ID="evenPage" class="bookPage" [style]="this.leftPageNumber === 0 ? 'width: 621px; height: 810px; url(images/noPageTile.png) repeat' : 'width: 621px; height: 810px; background-position: initial; background-size: initial; background-repeat: repeat; background-attachment: initial; background-origin: initial; background-clip: initial; background-color: white;'">-->
      <div id="evenPage" class="bookPage" [style.width.px]="pageDisplayWidth + 18" [style.height.px]="pageDisplayHeight + 18">
        <div class="clippingRect">
          <img #leftImage id="evenPageImage" style="display: block; position: absolute;" src="">
          <p *ngIf="hasResource && leftPageNumber!==0 && !leftImageLoaded" class="evenPageLoadingImage" style="width: 100%; text-align: center; height: 500px; line-height: 500px; font-weight: bold; color: black; font-size: xxx-large;" i18n="@@Loading Image">Loading Image</p>
          <p *ngIf="!hasResource" class="evenPageLoadingImage" style="width: 100%; text-align: center; height: 500px; line-height: 500px; font-weight: bold; color: black; font-size: x-large;" i18n="@@No PDF Uploaded Yet">No PDF Uploaded Yet</p>
          <img *ngIf="showGutter" id="evenPageGutter" class="pageGutter" src="assets/images/evenPageGutter.png" style="width: 21.6px;">

          <!-- Spine line (always visible) -->
          <div class="spine-line" style="position: absolute; right: 0; top: 9px; width: 1px; background-color: black;" [style.height.px]="pageDisplayHeight"></div>

          <div id="evenPage_outerVertMargin" class="margin vertMargin" [class.visible]="showGuideLines" [style.left.px]="9 + marginOutPx" style="top: 0;"></div>
          <div id="evenPage_innerVertMargin" class="margin vertMargin" [class.visible]="showGuideLines" [style.right.px]="9 + marginInPx" style="top: 0;"></div>
          <div id="evenPage_topHorMargin" class="margin horMargin" [class.visible]="showGuideLines" [style.top.px]="9 + marginTopPx"></div>
          <div id="evenPage_bottomHorMargin" class="margin horMargin" [class.visible]="showGuideLines" [style.bottom.px]="9 + marginBottomPx"></div>

          <div id="evenPage_outerVertCut" class="cutLine vertCut" style="left: 8px;"></div>
          <div id="evenPage_topHorCut" class="cutLine horCut" style="top: 8px;"></div>
          <div id="evenPage_bottomHorCut" class="cutLine horCut" style="bottom: 8px;"></div>

          <div id="evenPage_topDangerZone" class="dangerZone dangerZoneHor" style="top: 0px;"></div>
          <div id="evenPage_bottomDangerZone" class="dangerZone dangerZoneHor" style="bottom: 0px;"></div>
          <div id="evenPage_leftDangerZone" class="dangerZone dangerZoneVert" [style.height.px]="pageDisplayHeight" style="top: 9px; left: 0px;"></div>

          <!-- SVG-based horizontal ruler for left page (top) -->
          <svg *ngIf="showRuler" class="ruler ruler-horizontal" [attr.width]="pageDisplayWidth" [attr.height]="20" style="position: absolute; top: 0; left: 9px;">
            <line *ngFor="let tick of (unit === 'in' ? getHorizontalRulerTicksInches(pageDisplayWidth) : getHorizontalRulerTicksMm(pageDisplayWidth))"
                  [attr.x1]="tick.position"
                  [attr.y1]="20 - tick.height"
                  [attr.x2]="tick.position"
                  [attr.y2]="20"
                  stroke="black"
                  stroke-width="1" />
            <ng-container *ngFor="let tick of (unit === 'in' ? getHorizontalRulerTicksInches(pageDisplayWidth) : getHorizontalRulerTicksMm(pageDisplayWidth))">
              <text *ngIf="tick.label"
                    [attr.x]="tick.position + 2"
                    [attr.y]="14"
                    [attr.font-size]="isRTL ? 144 : 72"
                    font-weight="bold"
                    fill="black">{{tick.label}}</text>
            </ng-container>
          </svg>

          <!-- SVG-based vertical ruler for left page (right side, at spine) -->
          <svg *ngIf="showRuler" class="ruler ruler-vertical" [attr.width]="20" [attr.height]="pageDisplayHeight" style="position: absolute; bottom: 9px; right: 0;">
            <line *ngFor="let tick of (unit === 'in' ? getVerticalRulerTicksInches(pageDisplayHeight) : getVerticalRulerTicksMm(pageDisplayHeight))"
                  [attr.x1]="20 - tick.height"
                  [attr.y1]="pageDisplayHeight - tick.position"
                  [attr.x2]="20"
                  [attr.y2]="pageDisplayHeight - tick.position"
                  stroke="black"
                  stroke-width="1" />
            <ng-container *ngFor="let tick of (unit === 'in' ? getVerticalRulerTicksInches(pageDisplayHeight) : getVerticalRulerTicksMm(pageDisplayHeight))">
              <text *ngIf="tick.label"
                    [attr.x]="2"
                    [attr.y]="pageDisplayHeight - tick.position - 2"
                    [attr.font-size]="isRTL ? 144 : 72"
                    font-weight="bold"
                    fill="black">{{tick.label}}</text>
            </ng-container>
          </svg>

          <!-- Debug grid lines -->
          <ng-container *ngIf="showDebugGrid">
            <div *ngFor="let line of leftPageDebugLines"
                 class="debug-grid-line"
                 [class.debug-grid-vertical]="line.axis === 'vertical'"
                 [class.debug-grid-horizontal]="line.axis === 'horizontal'"
                 [style.border-style]="line.style"
                 [style.left.px]="line.axis === 'vertical' ? line.position : null"
                 [style.top.px]="line.axis === 'horizontal' ? line.position : null">
            </div>
          </ng-container>
        </div>
<!--        <img ID="pageBackward" alt="Previous Pages" title="Back" src="assets/images/pageBackward.png" onclick="bookBody.pages.pageImages.decrementCurrentPages();">-->
        <button id="evenPageShiftUp" mat-icon-button (click)="draft.draftBody.leftVerticalShift = draft.draftBody.leftVerticalShift - 9"><mat-icon i18n-title="@@Shift page up" title="Shift page up" color="primary">arrow_upward</mat-icon></button>
        <button id="evenPageShiftDown" mat-icon-button (click)="draft.draftBody.leftVerticalShift = draft.draftBody.leftVerticalShift + 9"><mat-icon i18n-title="@@Shift page down" title="Shift page down" color="primary">arrow_downward</mat-icon></button>
        <button id="evenPageShiftLeft" mat-icon-button (click)="draft.draftBody.leftHorizontalShift = draft.draftBody.leftHorizontalShift - 9"><mat-icon i18n-title="@@Shift page left" title="Shift page left" color="primary">arrow_back</mat-icon></button>
        <button id="evenPageShiftRight" mat-icon-button (click)="draft.draftBody.leftHorizontalShift = draft.draftBody.leftHorizontalShift + 9"><mat-icon i18n-title="@@Shift page right" title="Shift page right" color="primary">arrow_forward</mat-icon></button>
      </div>
    </td>
    <td id="oddPageWrapper">
      <div id="oddPage" class="bookPage" [style.width.px]="pageDisplayWidth + 18" [style.height.px]="pageDisplayHeight + 18">
        <div class="clippingRect">
          <img #rightImage id="oddPageImage" style="display: block; position: absolute;" src="">
          <p *ngIf="hasResource && rightPageNumber<draft.draftBody.numPages && !rightImageLoaded" class="oddPageLoadingImage" style="width: 100%; text-align: center; height: 500px; line-height: 500px; font-weight: bold; color: black; font-size: xxx-large;" i18n="@@Loading Image">Loading Image</p>
          <p *ngIf="!hasResource" class="oddPageLoadingImage" style="width: 100%; text-align: center; height: 500px; line-height: 500px; font-weight: bold; color: black; font-size: x-large;" i18n="@@No PDF Uploaded Yet">No PDF Uploaded Yet</p>
          <img *ngIf="showGutter" id="oddPageGutter" class="pageGutter" src="assets/images/oddPageGutter.png" style="width: 21.6px;">

          <!-- Spine line (always visible) -->
          <div class="spine-line" style="position: absolute; left: 0; top: 9px; width: 1px; background-color: black;" [style.height.px]="pageDisplayHeight"></div>

          <div id="oddPage_outerVertMargin" class="margin vertMargin" [class.visible]="showGuideLines" [style.right.px]="9 + marginOutPx" style="top: 0;"></div>
          <div id="oddPage_innerVertMargin" class="margin vertMargin" [class.visible]="showGuideLines" [style.left.px]="9 + marginInPx" style="top: 0;"></div>
          <div id="oddPage_topHorMargin" class="margin horMargin" [class.visible]="showGuideLines" [style.top.px]="9 + marginTopPx"></div>
          <div id="oddPage_bottomHorMargin" class="margin horMargin" [class.visible]="showGuideLines" [style.bottom.px]="9 + marginBottomPx"></div>

          <div id="oddPage_outerVertCut" class="cutLine vertCut" style="right: 8px;"></div>
          <div id="oddPage_topHorCut" class="cutLine horCut" style="top: 8px;"></div>
          <div id="oddPage_bottomHorCut" class="cutLine horCut" style="bottom: 8px;"></div>

          <div id="oddPage_topDangerZone" class="dangerZone dangerZoneHor" style="top: 0px;"></div>
          <div id="oddPage_bottomDangerZone" class="dangerZone dangerZoneHor" style="bottom: 0px;"></div>
          <div id="oddPage_rightDangerZone" class="dangerZone dangerZoneVert" [style.height.px]="pageDisplayHeight" style="right: 0px; top: 9px;"></div>

          <!-- SVG-based horizontal ruler for right page (top, flipped) -->
          <svg *ngIf="showRuler" class="ruler ruler-horizontal" [attr.width]="pageDisplayWidth" [attr.height]="20" style="position: absolute; top: 0; right: 9px;">
            <line *ngFor="let tick of (unit === 'in' ? getHorizontalRulerTicksInches(pageDisplayWidth) : getHorizontalRulerTicksMm(pageDisplayWidth))"
                  [attr.x1]="pageDisplayWidth - tick.position"
                  [attr.y1]="20 - tick.height"
                  [attr.x2]="pageDisplayWidth - tick.position"
                  [attr.y2]="20"
                  stroke="black"
                  stroke-width="1" />
            <ng-container *ngFor="let tick of (unit === 'in' ? getHorizontalRulerTicksInches(pageDisplayWidth) : getHorizontalRulerTicksMm(pageDisplayWidth))">
              <text *ngIf="tick.label"
                    [attr.x]="pageDisplayWidth - tick.position - 12"
                    [attr.y]="14"
                    [attr.font-size]="isRTL ? 144 : 72"
                    font-weight="bold"
                    fill="black">{{tick.label}}</text>
            </ng-container>
          </svg>

          <!-- SVG-based vertical ruler for right page (left side, at spine) -->
          <svg *ngIf="showRuler" class="ruler ruler-vertical" [attr.width]="20" [attr.height]="pageDisplayHeight" style="position: absolute; top: 9px; left: 0;">
            <line *ngFor="let tick of (unit === 'in' ? getVerticalRulerTicksInches(pageDisplayHeight) : getVerticalRulerTicksMm(pageDisplayHeight))"
                  [attr.x1]="0"
                  [attr.y1]="tick.position"
                  [attr.x2]="tick.height"
                  [attr.y2]="tick.position"
                  stroke="black"
                  stroke-width="1" />
            <ng-container *ngFor="let tick of (unit === 'in' ? getVerticalRulerTicksInches(pageDisplayHeight) : getVerticalRulerTicksMm(pageDisplayHeight))">
              <text *ngIf="tick.label"
                    [attr.x]="2"
                    [attr.y]="tick.position + 14"
                    [attr.font-size]="isRTL ? 144 : 72"
                    font-weight="bold"
                    fill="black">{{tick.label}}</text>
            </ng-container>
          </svg>

          <!-- Debug grid lines -->
          <ng-container *ngIf="showDebugGrid">
            <div *ngFor="let line of rightPageDebugLines"
                 class="debug-grid-line"
                 [class.debug-grid-vertical]="line.axis === 'vertical'"
                 [class.debug-grid-horizontal]="line.axis === 'horizontal'"
                 [style.border-style]="line.style"
                 [style.right.px]="line.axis === 'vertical' ? line.position : null"
                 [style.top.px]="line.axis === 'horizontal' ? line.position : null">
            </div>
          </ng-container>
        </div>
<!--        <img ID="pageForward" alt="Next Pages" title="Forward" src="/assets/images/pageForward.png" onclick="bookBody.pages.pageImages.incrementCurrentPages();">-->
        <button id="oddPageShiftUp" mat-icon-button (click)="draft.draftBody.rightVerticalShift = draft.draftBody.rightVerticalShift - 9"><mat-icon i18n-title="@@Shift page up" title="Shift page up" color="primary">arrow_upward</mat-icon></button>
        <button id="oddPageShiftDown" mat-icon-button (click)="draft.draftBody.rightVerticalShift = draft.draftBody.rightVerticalShift + 9"><mat-icon i18n-title="@@Shift page down" title="Shift page down" color="primary">arrow_downward</mat-icon></button>
        <button id="oddPageShiftLeft" mat-icon-button (click)="draft.draftBody.rightHorizontalShift = draft.draftBody.rightHorizontalShift - 9"><mat-icon i18n-title="@@Shift page left" title="Shift page left" color="primary">arrow_back</mat-icon></button>
        <button id="oddPageShiftRight" mat-icon-button (click)="draft.draftBody.rightHorizontalShift = draft.draftBody.rightHorizontalShift + 9"><mat-icon i18n-title="@@Shift page right" title="Shift page right" color="primary">arrow_forward</mat-icon></button>
      </div>
    </td>
    <td>
    </td>
  </tr>
  </tbody>
</table>

